import { useEffect } from 'react';
import styles from './VideoModal.module.scss';
import { RaceTeamVideoType } from '@/types/raceTeamVideo.types';

type VideoModalProps = {
  isOpen: boolean;
  onClose: () => void;
} & Pick<RaceTeamVideoType, 'videoUrl' | 'videoType'>;

const VideoModal = ({
  isOpen,
  onClose,
  videoUrl,
  videoType,
}: VideoModalProps) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={`${styles.modalContent} ${videoType === 'youtube' ? styles.youtubeContent : styles.localContent}`}
        onClick={(e) => e.stopPropagation()}
      >
        {videoType === 'local' ? (
          <video src={videoUrl} controls autoPlay className={styles.videoFrame}>
            Your browser does not support the video tag.
          </video>
        ) : (
          <iframe
            src={videoUrl}
            className={styles.videoFrame}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>
    </div>
  );
};

export default VideoModal;
